/* fetalADN · Popups (bienvenida BEBE7, quiz NIPT, quiz de suplementos) */
(function () {
  var root = document.getElementById('fd-pp');
  if (!root || root.dataset.page === 'off') return;
  if (window.Shopify && Shopify.designMode) return;

  function get(store, k) { try { return window[store].getItem(k); } catch (e) { return null; } }
  function set(store, k, v) { try { window[store].setItem(k, v); } catch (e) {} }
  function track(name, params) {
    try { if (window.gtag) gtag('event', name, params || {}); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, params || {})); } catch (e) {}
  }

  var page = root.dataset.page;
  var active = null, lastFocus = null, restore = null;

  function open(name) {
    if (active) return;
    var dlg = root.querySelector('[data-fd-pp="' + name + '"]');
    if (!dlg) return;
    lastFocus = document.activeElement;
    root.hidden = false; dlg.hidden = false; active = dlg;
    document.documentElement.classList.add('fd-pp-open');
    set('sessionStorage', 'fd_pp_any', '1');
    var f = dlg.querySelector('input,button:not(.fd-pp__x),select');
    setTimeout(function () { (f || dlg.querySelector('.fd-pp__x')).focus({ preventScroll: true }); }, 60);
    track('popup_view', { popup: name });
  }
  function close() {
    if (!active) return;
    var name = active.dataset.fdPp;
    active.hidden = true; root.hidden = true;
    document.documentElement.classList.remove('fd-pp-open');
    if (restore) { restore(); restore = null; }
    active = null;
    if (lastFocus && lastFocus.focus) try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    track('popup_close', { popup: name });
  }
  root.addEventListener('click', function (e) { if (e.target.closest('[data-fd-pp-close]')) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && active) close(); });

  function when(delayMs, scrollRatio, fn, exitIntent) {
    var done = false;
    function go() { if (done) return; done = true; window.removeEventListener('scroll', onScroll); document.removeEventListener('mouseout', onOut); fn(); }
    function onScroll() {
      var h = document.documentElement.scrollHeight - innerHeight;
      if (h > 0 && scrollY / h >= scrollRatio) go();
    }
    function onOut(e) { if (!e.relatedTarget && e.clientY <= 0) go(); }
    setTimeout(go, delayMs);
    window.addEventListener('scroll', onScroll, { passive: true });
    if (exitIntent && matchMedia('(pointer:fine)').matches) document.addEventListener('mouseout', onOut);
  }

  /* ---------- 1) Bienvenida BEBE7 ---------- */
  var welcome = root.querySelector('[data-fd-pp="welcome"]');
  if (welcome) {
    var form = welcome.querySelector('form');
    var msg = welcome.querySelector('[data-msg]');
    /* 1) Copia del correo en HubSpot (sin CAPTCHA). 2) Envío nativo a Shopify, que agrega su verificación anti-spam y recarga la página. */
    form.addEventListener('submit', function (e) {
      if (form.dataset.go === '1') return;
      e.preventDefault();
      var email = (form.querySelector('[type=email]').value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { msg.textContent = 'Escribe un correo válido.'; return; }
      var btn = form.querySelector('button[type=submit]'); btn.disabled = true; btn.textContent = 'Enviando…';
      set('localStorage', 'fd_pp_welcome', 'done');
      set('localStorage', 'fd_pp_pending', '1');
      track('generate_lead', { lead_type: 'newsletter', popup: 'bienvenida', coupon: 'BEBE7' });
      try { if (window.fbq) fbq('track', 'Lead', { content_name: 'Popup bienvenida BEBE7' }); } catch (err) {}
      var ck = (document.cookie.match(/hubspotutk=([^;]+)/) || [])[1];
      var ctx = { pageUri: location.href, pageName: document.title }; if (ck) ctx.hutk = ck;
      var hs = fetch('https://api.hsforms.com/submissions/v3/integration/submit/' + root.dataset.hsPortal + '/' + root.dataset.hsForm, {
        method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ fields: [{ name: 'email', value: email }, { name: 'fetaladn_web__origen', value: 'Popup bienvenida BEBE7' }, { name: 'fetaladn_web___interes', value: 'Newsletter / código BEBE7' }],
          context: ctx })
      }).catch(function () {});
      var go = function () { form.dataset.go = '1'; btn.disabled = false; if (form.requestSubmit) form.requestSubmit(btn); else form.submit(); };
      Promise.race([hs, new Promise(function (r) { setTimeout(r, 2500); })]).then(go);
      /* Si la verificación tarda, entrega el código de todos modos */
      setTimeout(function () { if (get('localStorage', 'fd_pp_pending') === '1') { set('localStorage', 'fd_pp_pending', ''); showWelcomeDone(); } }, 12000);
    });
  }
  function showWelcomeDone() {
    if (!welcome) return;
    welcome.querySelector('[data-step=form]').hidden = true;
    welcome.querySelector('[data-step=done]').hidden = false;
    open('welcome');
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-copy]'); if (!b) return;
    var t = b.getAttribute('data-copy');
    (navigator.clipboard ? navigator.clipboard.writeText(t) : Promise.reject()).then(function () { b.textContent = '¡Copiado!'; }, function () { b.textContent = t; });
  });

  /* ---------- 2) Quiz NIPT en ventana emergente ---------- */
  function openNipt() {
    var sec = document.getElementById('quiz-nipt');
    var dlg = root.querySelector('[data-fd-pp="nipt"]');
    if (!sec || !dlg) return;
    var mark = document.createComment('fd-quiz-nipt');
    sec.parentNode.insertBefore(mark, sec);
    dlg.querySelector('[data-slot]').appendChild(sec);
    restore = function () { mark.parentNode.insertBefore(sec, mark); mark.remove(); };
    open('nipt');
  }

  /* Código NIPT7 al terminar el quiz NIPT (en página o en ventana emergente) */
  (function () {
    var sec = document.getElementById('quiz-nipt'), code = root.dataset.niptCode;
    if (!sec || !code) return;
    new MutationObserver(function () {
      var ok = sec.querySelector('.fd-nq__ok');
      if (!ok || sec.querySelector('.fd-nq__code')) return;
      var d = document.createElement('div'); d.className = 'fd-nq__code';
      d.innerHTML = 'Tu código por completar el quiz<strong>' + code + '</strong><small>7% de descuento en tu prueba prenatal (NIPT, Prenatal Premium o Gender Test). Escríbelo al pagar; válido una vez por cliente y no se combina con otras promociones.</small>';
      ok.insertAdjacentElement('afterend', d);
      track('coupon_reveal', { coupon: code, popup: 'quiz_nipt' });
    }).observe(sec, { childList: true, subtree: true });
  })();

  /* ---------- 3) Quiz de suplementos (Typeform) ---------- */
  function loadTf(cb) {
    if (window.tf && window.tf.createPopup) return cb();
    if (!window.__fdTf) {
      window.__fdTf = 1;
      var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = 'https://embed.typeform.com/next/css/popup.css'; document.head.appendChild(l);
      var s = document.createElement('script'); s.src = 'https://embed.typeform.com/next/embed.js'; s.async = true; document.head.appendChild(s);
    }
    var n = 0, t = setInterval(function () { if (window.tf && window.tf.createPopup) { clearInterval(t); cb(); } else if (++n > 50) clearInterval(t); }, 200);
  }
  function openSupp() {
    loadTf(function () {
      if (document.querySelector('.tf-v1-popup')) return;
      var p = window.tf.createPopup(root.dataset.suppForm, {
        size: 100, opacity: 100, hidden: { origen: location.pathname, popup: 'auto' },
        transitiveSearchParams: ['utm_source', 'utm_medium', 'utm_campaign'],
        onSubmit: function () { track('generate_lead', { lead_type: 'paciente', popup: 'quiz_suplementos' }); },
        onClose: function () { track('popup_close', { popup: 'quiz_suplementos' }); }
      });
      p.open(); set('sessionStorage', 'fd_pp_any', '1'); track('popup_view', { popup: 'quiz_suplementos' });
    });
  }

  /* ---------- Reglas de aparición ---------- */
  if (get('localStorage', 'fd_pp_pending') === '1') {
    set('localStorage', 'fd_pp_pending', '');
    setTimeout(showWelcomeDone, 400);
  } else
  if (page === 'nipt' && !get('sessionStorage', 'fd_pp_nipt') && document.getElementById('quiz-nipt')) {
    when(6000, 0.25, function () { if (active) return; set('sessionStorage', 'fd_pp_nipt', '1'); openNipt(); });
  } else if (page === 'supp' && !get('sessionStorage', 'fd_pp_supp')) {
    when(4000, 0.3, function () { if (active) return; set('sessionStorage', 'fd_pp_supp', '1'); openSupp(); });
  } else if (!get('localStorage', 'fd_pp_welcome') && !get('sessionStorage', 'fd_pp_any')) {
    when(8000, 0.45, function () {
      if (active || get('localStorage', 'fd_pp_welcome')) return;
      set('localStorage', 'fd_pp_welcome', 'seen'); open('welcome');
    }, true);
  }

  /* Disparadores manuales: cualquier enlace a #bienvenida, #quiz-nipt-popup o #quiz-suplementos */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href$="#bienvenida"],a[href$="#quiz-nipt-popup"],a[href$="#quiz-suplementos"]');
    if (!a) return;
    var h = a.getAttribute('href');
    if (h.indexOf('#bienvenida') > -1) { e.preventDefault(); open('welcome'); }
    else if (h.indexOf('#quiz-nipt-popup') > -1 && document.getElementById('quiz-nipt')) { e.preventDefault(); openNipt(); }
    else if (h.indexOf('#quiz-suplementos') > -1) { e.preventDefault(); openSupp(); }
  });
})();
